import { tourAndGalleryService } from 'src/services/src/service/tour-and-gallery/tour-and-gallery.service';
import { Dispatch } from 'src/components-bl/types';
import {
  TourAndGalleryActionTypes,
  GetSettingsArgs,
  UpdateSettingsArgs,
  GetSettingsRequestPayload,
  GetSettingsSuccessPayload,
  GetSettingsErrorPayload,
  UpdateSettingsRequestPayload,
  UpdateSettingsSuccessPayload,
  UpdateSettingsErrorPayload,
  GetCatalogPreviewErrorPayload,
  GetSettingsRequestAction,
  GetSettingsSuccessAction,
  GetSettingsErrorAction,
  UpdateSettingsRequestAction,
  UpdateSettingsSuccessAction,
  UpdateSettingsErrorAction,
  GetCatalogPreviewErrorAction,
  NotifyIsDirtyAction,
} from './types';

const tourAndGalleryActions = {
  getSettingsRequest: (payload: GetSettingsRequestPayload): GetSettingsRequestAction => ({
    type: TourAndGalleryActionTypes.GetSettingsRequest,
    payload,
  }),

  getSettingsSuccess: (payload: GetSettingsSuccessPayload): GetSettingsSuccessAction => ({
    type: TourAndGalleryActionTypes.GetSettingsSuccess,
    payload,
  }),

  getSettingsError: (payload: GetSettingsErrorPayload): GetSettingsErrorAction => ({
    type: TourAndGalleryActionTypes.GetSettingsError,
    payload,
  }),

  updateSettingsRequest: (payload: UpdateSettingsRequestPayload): UpdateSettingsRequestAction => ({
    type: TourAndGalleryActionTypes.UpdateSettingsRequest,
    payload,
  }),

  updateSettingsSuccess: (payload: UpdateSettingsSuccessPayload): UpdateSettingsSuccessAction => ({
    type: TourAndGalleryActionTypes.UpdateSettingsSuccess,
    payload,
  }),

  updateSettingsError: (payload: UpdateSettingsErrorPayload): UpdateSettingsErrorAction => ({
    type: TourAndGalleryActionTypes.UpdateSettingsError,
    payload,
  }),
};

export const tourAndGalleryActionsMethods = {
  fetchSettings:
    ({ shopId }: GetSettingsArgs) =>
    async (dispatch: Dispatch): Promise<void> => {
      try {
        dispatch(tourAndGalleryActions.getSettingsRequest({ shopId }));
        const settings = await tourAndGalleryService.get(shopId);
        dispatch(tourAndGalleryActions.getSettingsSuccess({ shopId, settings }));
      } catch (error) {
        dispatch(tourAndGalleryActions.getSettingsError({ error }));
      }
    },

  updateSettings:
    ({ shopId, settings }: UpdateSettingsArgs) =>
    async (dispatch: Dispatch): Promise<void> => {
      try {
        dispatch(tourAndGalleryActions.updateSettingsRequest({ shopId, settings }));
        const updated = await tourAndGalleryService.update(shopId, settings);
        dispatch(tourAndGalleryActions.updateSettingsSuccess({ shopId, settings: updated }));
      } catch (error) {
        dispatch(tourAndGalleryActions.updateSettingsError({ error }));
      }
    },

  notifyIsDirty: (isDirty: boolean): NotifyIsDirtyAction => ({
    type: TourAndGalleryActionTypes.NotifyIsDirty,
    payload: { isDirty },
  }),

  getCatalogPreviewError: (
    payload: GetCatalogPreviewErrorPayload
  ): GetCatalogPreviewErrorAction => ({
    type: TourAndGalleryActionTypes.GetCatalogPreviewError,
    payload,
  }),
};
